// extracted by mini-css-extract-plugin
export default {"actions":"role-skill-management_actions__HBKPy","description":"role-skill-management_description__wSGyT"};